import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ItemList from './ItemList/ItemList';
import { SubNavStyles } from './SubNav.styled';

import { useOnClickOutside } from 'pubweb-smokey/dist/hooks/useOnClickOutside';

const SubNav = ({
  navText,
  navId,
  navItems,
  closeHandler,
  selectedItem = undefined,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const subNavRef = useRef();

  useEffect(() => {
    closeHandler(navId, isOpen);
  }, [isOpen, closeHandler, navId]);

  // This is a modeled on useOnClickOutside. It is used to handle tabbing out of the SubNav.
  const useOnFocusIn = (ref, handler) => {
    useEffect(() => {
      const listener = (event) => {
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }
        handler(event);
      };
      document.addEventListener('focusin', listener);
      return () => {
        document.removeEventListener('focusin', listener);
      };
    }, [ref, handler]);
  };

  const handleOutsideClicks = (e) => {
    if (isOpen) {
      const clickableArea = subNavRef.current;
      if (
        !clickableArea ||
        (e.target !== clickableArea && !clickableArea.contains(e.target))
      ) {
        setIsOpen(false);
      }
    }
  };

  if (typeof document !== 'undefined') {
    useOnClickOutside(subNavRef, handleOutsideClicks); // eslint-disable-line react-hooks/rules-of-hooks
    useOnFocusIn(subNavRef, handleOutsideClicks); // eslint-disable-line react-hooks/rules-of-hooks
  }

  return (
    <SubNavStyles ref={subNavRef}>
      <button
        type="button"
        id={`filter-button-${navId}`}
        title={navText}
        className={'filter-button standard ' + (isOpen && 'active')}
        onClick={() => setIsOpen((isOpen) => !isOpen)}
      >
        {navText}
      </button>

      {isOpen && (
        <ItemList
          items={navItems}
          navId={navId}
          selectedItem={selectedItem}
          onSelect={() => setIsOpen(false)}
        />
      )}
    </SubNavStyles>
  );
};

SubNav.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  navId: PropTypes.any.isRequired,
  navItems: PropTypes.any.isRequired,
  navText: PropTypes.any.isRequired,
  selectedItem: PropTypes.any,
};

export default SubNav;
